@switch (dataType) {
  @case ('array') {
    <input
      class="bd-text-input tall"
      [formControl]="fieldCtrl"
      [name]="fieldName"
      type="text"
      placeholder="Comma-separated list"
    />
  }
  @case ('boolean') {
    <mat-button-toggle-group
      class="button-group-input"
      [name]="fieldName"
      [formControl]="fieldCtrl"
    >
      <mat-button-toggle value="">None</mat-button-toggle>
      <mat-button-toggle value="true">True</mat-button-toggle>
      <mat-button-toggle value="false">False</mat-button-toggle>
    </mat-button-toggle-group>
  }
  @case ('datetime') {
    <input
      class="bd-text-input tall"
      [formControl]="fieldCtrl"
      [name]="fieldName"
      type="datetime-local"
    />
  }
  @case ('date') {
    <input class="bd-text-input tall" [formControl]="fieldCtrl" [name]="fieldName" type="date" />
  }
  @case ('file') {
    <blaze-upload-button class="h-40" (fileChanged)="fileChanged($event, fieldCtrl)" />
  }
  @case ('number') {
    <input class="bd-text-input tall" [formControl]="fieldCtrl" [name]="fieldName" type="number" />
  }
  @case ('time') {
    <input class="bd-text-input tall" [formControl]="fieldCtrl" [name]="fieldName" type="time" />
  }
  @default {
    <input class="bd-text-input tall" [formControl]="fieldCtrl" [name]="fieldName" type="text" />
  }
}
